import { LOGO_URL, handleCallClick } from "./constants";

export default function Nav() {
  return (
    <nav className="border-b border-white/10 bg-[#0b101b]/90 backdrop-blur sticky top-0 z-50 px-6 py-3">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src={LOGO_URL}
            alt="Revive & Drive Auto LLC logo"
            data-testid="nav-logo"
            className="h-11 w-auto rounded-md border border-white/10"
          />
          <span className="font-bold text-base sm:text-lg tracking-tight uppercase">
            Revive &amp; Drive Auto LLC
          </span>
        </div>
        <div className="flex items-center gap-4">
          <a
            href="#quote"
            data-testid="nav-request-service-link"
            className="hidden sm:inline-block font-mono-lbl text-xs tracking-widest uppercase text-slate-300 hover:text-white transition-colors"
          >
            Request Service
          </a>
          <button
            type="button"
            onClick={handleCallClick}
            data-testid="nav-emergency-call-button"
            className="bg-[#ff4b2b] hover:bg-[#e03d1f] text-white px-4 py-2 rounded-lg font-semibold text-sm transition-colors active:scale-95 shadow-lg shadow-[#ff4b2b]/30"
          >
            Emergency Call
          </button>
        </div>
      </div>
    </nav>
  );
}
